export default "__VITE_ASSET__DrkzAXoj__"